declare namespace $ {

	export class $mol_icon_card_text_outline extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=outline.view.tree.d.ts.map